export default {
      id: "icon-timer-usage",
      viewBox: "0 0 24 24",
      url: "/" + "assets/sprite.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }